export default __webpack_public_path__ + "static/media/vesting_image.fbc6d693.svg";